<section class="home-hero" data-aos="fade-in">
  <div class="hero-wrapper">
    <div class="container-full">
      <div class="row">
        <div class="col-lg-6" data-aos="fade-in" data-aos-delay="100">
          <div class="text-wrapper">
            <h1>{{ 'home.hero-title' | translate }}</h1>
            <h2>{{ 'home.hero-subtitle' | translate }}</h2>
            <p>{{ 'home.hero-text' | translate }}</p>
          </div>

          <div class="row">
            <div class="col-sm-10">
              <form (submit)="onSubmit($event)" class="search-control">
                <input type="text" autocomplete="off" [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}"
                  [placeholder]="('home.job search placeholder' | translate) + '...'">
                <div class="btns">
                  <button class="btn btn-primary" type="submit" (click)="onSubmit($event)">{{'home.search-btn' | translate}}</button>
                </div>
              </form>
            </div>
          </div>
          <div class="top-search">
            <span>{{'home.most search' | translate}}:</span>
            <a (click)="trackTopSearch(item.job_title)" routerLink="/jobs" [queryParams]="{search: item.job_title}"
              class="label" *ngFor="let item of statistics?.data?.most_applied_jobs">
              {{item.job_title}}
            </a>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-in" data-aos-delay="200">
          <div class="img-container">
            <img src="assets/images/homeNew/Hero_area_character-{{lang}}.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="clients" data-aos="fade-in" style="overflow: hidden;">
  <h2 class="title">{{'home.Our Clients' | translate}}</h2>
  <swiper-container class="slider" #clientsSwiper data-aos="fade-left" data-aos-delay="500" [slidesPerView]="'auto'"
    [loop]="true" autoplay-delay="0" [autoplay]="{ delay: 0, disableOnInteraction: false, pauseOnMouseEnter: false }"
    [speed]="5000" [freeMode]="true" [grabCursor]="true">
    <swiper-slide class="item" *ngFor="let img of clients">
      <img [src]="img" alt="">
    </swiper-slide>
    <swiper-slide class="item" *ngFor="let img of clients">
      <img [src]="img" alt="">
    </swiper-slide>
  </swiper-container>
</section>

<section class="make-cv">
  <div class="content">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10">
          <div class="row align-items-center justify-content-between">
            <div class="col-md-7" data-aos="fade-left">
              <div class="text-wrapper">
                <h2 class="title" [innerHTML]="'home.make cv title' | translate"></h2>
                <p>{{ 'home.make cv text' | translate }}</p>
                <ul>
                  <li>{{ 'home.make cv list1' | translate }}</li>
                  <li>{{ 'home.make cv list2' | translate }}</li>
                  <li>{{ 'home.make cv list3' | translate }}</li>
                </ul>
                <div class="text-md-start text-center">
                  <a href="{{env.appUrl}}/register?lang={{lang}}"
                    (click)="analytics.event('cta_click', { source: 'make_cv' })" class="btn btn-primary">
                    {{ 'home.make cv btn' | translate }}
                  </a>
                </div>
              </div>
            </div>
            <div class="col-md-5 text-center mt-4 mt-md-0" data-aos="fade-in" data-aos-delay="200">
              <img src="assets/images/homeNew/make_cv-{{lang}}.svg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="test-skills">
  <div class="content">
    <div class="container">
      <div class="row">
        <div class="col-md-11">
          <div class="row align-items-end flex-md-row flex-column-reverse">
            <div class="col-md-6 text-center mb-4 mb-md-0" data-aos="fade-in" data-aos-delay="200">
              <img src="assets/images/homeNew/test_skills-{{lang}}.png" alt="">
            </div>
            <div class="col-md-6" data-aos="fade-left">
              <div class="text-wrapper">
                <h2 class="title" [innerHTML]="'home.test skills title' | translate"></h2>
                <p>{{ 'home.test skills text' | translate }}</p>
                <ul>
                  <li>{{ 'home.test skills list1' | translate }}</li>
                  <li>{{ 'home.test skills list2' | translate }}</li>
                  <li>{{ 'home.test skills list3' | translate }}</li>
                  <li>{{ 'home.test skills list4' | translate }}</li>
                </ul>
                <div class="text-md-start text-center mb-md-0 mb-4">
                  <a href="{{env.appUrl}}/register?lang={{lang}}"
                    (click)="analytics.event('cta_click', { source: 'start_test' })" class="btn btn-primary">
                    {{ 'home.test skills btn' | translate }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="jobs-category" data-aos="fade-up" *ngIf="domains?.data?.list.length">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-10">
        <div class="content">
          <div class="text-center">
            <h2 class="title">{{ 'home.jobs category title' | translate }}</h2>
            <p>{{ 'home.jobs category text' | translate }}</p>
          </div>
          <div class="row g-4">
            <div class="col-xxl-3 col-md-4 col-6" *ngFor="let item of domains.data.list; let i = index"
              data-aos="fade-up">
              <a routerLink="/jobs" [queryParams]="{domain_id: item.id, domain_name: item.name}"
                (click)="trackSource('job_category_click', item)" class="item">
                <div class="img-container">
                  <img [src]="item.icon" alt="">
                </div>
                <h3>{{ item.name }}</h3>
                <h5>{{ item.description }}</h5>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="city-jobs" *ngIf="cities?.data?.length">
  <div class="container-full">
    <div class="text-center">
      <h2 class="title">{{ 'home.city jobs title' | translate }}</h2>
      <p>{{ 'home.city jobs text' | translate }}</p>
    </div>
  </div>
  <div class="content">
    <div class="container-full">
      <div class="row g-4">
        <div class="col-xl-2 col-4" *ngFor="let item of cities.data" data-aos="fade-up">
          <a routerLink="/jobs" [queryParams]="{city_id: item.city_id, city_name: item.name }"
            (click)="trackSource('job_city_click', item)" class="item">
            <h3>{{ item.name }}</h3>
            <h5>{{ 'home.city_jobs' | translate:{no: item.job_count} }}</h5>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
